if ($('#login').length) {
    require("./auth/login.js");
    require('./auth/steps-login.js');
}

if ($('#banner-container').length) require("./banners/banners");
if ($('#partners-highlight-host').length) require("./home/partners-highlight.js");
if ($('#home-training-summary').length) require("./home/training-summary.js");
if ($('.menu-feedback').length) require("./user/userFeedback");
if ($('#profile').length) require("./user/userProfile.js");
if ($('#change-password').length) require("./user/userChangePassword.js");
if ($('#notifications').length) require("./notification/notifications.js");
if ($('.user-account').length) require("./user/userAccount");
if ($('#extracts').length) require("./moves/extract");
if ($('#histories').length) require("./moves/history");
if ($('#product-list').length) require("./awards/products.js");
if ($('#product-detail').length) require("./awards/productDetail.js");
if ($('#news-list').length) require("./news/news.js");
if ($('#news-detail').length) require("./news/news-detail.js");
if ($('#news-container').length) require("./news/lasted-news-carousel.js");
if ($('#testimonials-container').length) require("./testimonials/testimonialsApproved");
if ($('#materials-list').length) require("./materials/materials.js");
if ($('#trainings-list').length) require("./materials/trainings.js");
if ($('#calendar').length) require("./events/events.js");
if ($('#contact-us').length) require("./contact/contact.js");
if ($('#request-control').length) require("./orders/rescueProducts.js");
if ($('#request-confirmation').length) require("./orders/rescueConfirmation.js");
if ($('#testimonials').length) require("./testimonials/testimonialsApproved.js");
if ($('#highlights-consultants').length) require("./highlights-consultants/paginate.js");
if ($('#my-learning').length) require("./trainings/myLearning.js");
if ($('#training-list').length) require("./trainings/training.js");
if ($('#training-detail').length) require("./trainings/trainingDetail.js");
if ($('#track-detail').length) require("./trainings/trackDetail.js");
if ($('.support-content').length) require("./support/support.js");
if ($('#campaigns-active').length) require("./campaigns/campaigns-list.js");
if ($('#campaign-banner').length) require("./campaigns/campaign-banner.js");
if ($('.js-partner-hubs-menu').length) require("./partner-hubs/menu-visibility.js");
if ($('#partner-hubs-listing').length ||$('#partner-hub-detail').length || $('#partner-hub-content-detail').length) require("./partner-hubs/partner-hubs");
